export const sort = [
  { label: "Nazwa", name: "name" },
  { label: "Stawka", name: "value" },
  { label: "Kraj", name: "country_code" },
];

export const filters = [
  {
    type: "input",
    name: "name",
    sort_id: "name",
    search_type: "matches",
  },
  {
    type: "input",
    name: "value",
    sort_id: "value",
    search_type: "matches",
  },
  {
    type: "input",
    name: "country_code",
    sort_id: "country_code",
    search_type: "matches",
  },
];
